import styled, { css } from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE, STONE_CLASSES } from '../../fields.constants';

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${em(8)};
`;

export const Name = styled.h1`
  ${({ theme }) => css`
    margin: 0;
    font-size: ${rem(22)};
    font-weight: ${theme.fontWeights[1]};
    color: ${theme.colors.nature.n5};
  `}
`;

export const Stats = styled.div`
  display: flex;
  gap: ${em(32)};
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(2)};
`;

const WARM = STONE_CLASSES.find(({ key }) => key === 'l').color;
const TONES = { good: PALETTE.brand, warm: WARM };

export const Value = styled.span`
  ${({ theme, $tone }) => css`
    font-family: ${theme.fonts.primary};
    font-size: 21px;
    font-weight: ${theme.fontWeights[1]};
    font-variant-numeric: tabular-nums;
    line-height: 1;
    color: ${TONES[$tone] ?? theme.colors.nature.n5};
  `}
`;

export const Label = styled.span`
  ${({ theme }) => css`
    font-size: ${rem(12)};
    color: ${theme.colors.nature.n3};
  `}
`;

export const Sub = styled.span`
  font-size: 11px;
  color: ${PALETTE.faint};
  font-variant-numeric: tabular-nums;
`;

export const Note = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-size: ${rem(12)};
    color: ${theme.colors.nature.n3};
  `}
`;
